import { ConfirmModal } from "@/components";
import { SocketManager } from "@/services";
import useChatStore from "@/store/chatStore";
import React, { useCallback } from "react";
import ChatInput from "./ChatInput";
import ChatInputEdit from "./ChatInputEdit";

interface Props {
  roomId: number;
}

const ChatInputWrap: React.FC<Props> = ({ roomId }) => {
  const editingMessage = useChatStore((state) => state.editingMessage);
  const setEditingMessage = useChatStore((state) => state.setEditingMessage);

  // Handle delete message
  const handleDeleteMessage = useCallback((messageId: number) => {
    // emit delete message socket event
    const socketManager = SocketManager.getInstance();
    socketManager.emitDeleteMessage({
      roomId: roomId.toString(),
      messageId: messageId,
    });

    // close dialog
    setEditingMessage();
  }, []);

  const handleCancelDeleteDialog = useCallback(() => {
    setEditingMessage();
  }, []);

  return (
    <div>
      {/* If editing message, show edit input */}
      {!!editingMessage && !editingMessage.isDeleted ? (
        <ChatInputEdit
          roomId={roomId}
          originalMessage={editingMessage.originalContent}
          messageId={editingMessage.messageId}
        />
      ) : (
        // New chat input
        <ChatInput roomId={roomId} />
      )}

      {/* Show confirmation delete message dialog */}
      {editingMessage && (
        <ConfirmModal
          type="delete"
          confirmation="このメッセージをすべてのユーザーから削除しますか？"
          open={editingMessage?.isDeleted}
          onConfirm={() => handleDeleteMessage(editingMessage.messageId)}
          onOpenChange={handleCancelDeleteDialog}
        />
      )}
    </div>
  );
};

export default ChatInputWrap;
